import { render, staticRenderFns } from "./DiscussionEditor.vue?vue&type=template&id=2b4b2b45&scoped=true&"
import script from "./DiscussionEditor.vue?vue&type=script&lang=js&"
export * from "./DiscussionEditor.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionEditor.vue?vue&type=style&index=0&id=2b4b2b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b2b45",
  null
  
)

export default component.exports